<template>
	<div class="basis-page-cls breath-task">
		<section class="basis-cls_filter">
			<table-search ref="tableSearch" @onSubjectLists="onSubjectLists" :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" @resetBasicFilter="resetBasicFilter">
				<div class="item item-dynamic" v-for="(item,index) in dynamicHeader" :key="index">
					<span class="label">{{item.label}}{{index+1}}：</span>
					 <el-select clearable v-model="item.model" placeholder="请选择" style="width: 180px;" @focus="onDynamicEvent">
					    <el-option
					      v-for="(item,index) in dynamicOptions"
					      :key="index"
					      :label="item.originalColumnName"
					      :value="item.originalColumnCode">
					    </el-option>
					  </el-select>
					<el-select clearable v-model="item.selectVal"  placeholder="请选择" style="width: 150px;margin: 0 10px;">
						<el-option label="大于" value="gtq"></el-option>
						<el-option label="不等于" value="neq"></el-option>
						<el-option label="小于" value="ltq"></el-option>
						<el-option label="等于" value="eq"></el-option>
					</el-select>
					<el-input clearable placeholder="请输入内容" v-model="item.inputVal" style="width: 150px;"></el-input>
					<i class="el-icon-circle-plus-outline" style="margin: 0 5px;" @click="addDynamic"></i>
					<i class="el-icon-delete-solid" @click="removeDynamic(index)" v-show="index != 0"></i>
				</div>
			</table-search>
		</section>
		<section class="basis-cls_table">
		    <div class="header">
		        <span class="title el-icon-document"> 数据列表 
					<el-popover
					    placement="right"
					    width="300"
					    v-model="column_visable"
					    trigger="manual">
					  <div>
						  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
							<div style="margin: 15px 0;"></div>
							<el-checkbox-group v-model="checkedColumnIds" @change="handleCheckedChange"  class="task_checkbox">
							  <el-checkbox v-for="(item,index) in check_columns" :label="item.originalColumnCode" :key="index">{{item.originalColumnName}}</el-checkbox>
							</el-checkbox-group>
							<div style="margin-top: 10px; display: flex; justify-content: center;">
								<el-button size="mini" @click.stop="onCancelColumn">取 消</el-button>
								<el-button type="primary" size="mini" @click.stop="onConfirmColumn">确 定</el-button>
							</div>
					  </div>
					    <el-tooltip class="item" effect="dark" content="列自定义" placement="top-start" slot="reference" v-if="userInfo.brandIdentify == brandName">
					        <i  class="el-icon-s-tools" style="cursor: pointer; margin-left: 5px;" @click="toShowColumn"></i>
					    </el-tooltip>
					 
					</el-popover>
				</span>
		        <div class="btns" v-if="userInfo.userType != 0">
					<p class="right">
						<el-input-number v-model="assignNum" size="small" :min="0" :max="total" placeholder="分配数量" :controls="false" style="margin-right: 5px;"></el-input-number>
						<el-button type="primary" size="small" @click.stop="onBatch">自动分配</el-button>
					</p>
					<el-button type="primary" size="small" class="right" @click.stop="onSpecify">指定分配</el-button>
					<el-button type="primary" size="small" class="right" @click.stop="onStatus">更改状态</el-button>
					<el-button type="primary" size="small" class="right" @click.stop="onTaskInfo" icon="el-icon-s-tools">任务状态</el-button>
		        </div>
		    </div>
		    <div class="table">
				<table-pagination
					v-loading="loading"
					ref="taskTable"
		            pagination
		            :data="list"
		            :column="column"
		            :total="total"
		            :page.sync="listQuery.pageNumber"
		            :limit.sync="listQuery.pageSize"
					@selection-change="handleSelectionChange"
		            @pagination="getList">
						<template v-slot:action="{row}">
							<el-button type="text" v-if="(row.isFinish ==0 || !row.isFinish) && row.userId" @click="toCallout(row)">执行任务</el-button>
							<el-divider direction="vertical" v-if="!row.userId && (row.isFinish ==0 || !row.isFinish) && row.userId"></el-divider>
							<el-button type="text" @click="onSpecifyToPerson(row)" v-if="!row.userId">分配坐席</el-button>
							<el-divider direction="vertical" v-if="row.isFinish == 1 && !row.userId"></el-divider>
							<el-button type="text" v-if="row.isFinish == 1" @click="onEdit(row)">修改任务</el-button>
							<el-divider direction="vertical" v-if="row.isFinish == 1"></el-divider>
							<el-button type="text" @click="onResetTask(row)" v-if="row.isFinish == 1">重开任务</el-button>
							<el-divider direction="vertical" v-if="userInfo.userType != '0'"></el-divider>
							<el-button type="text" @click="handleDetail(row)" v-if="userInfo.userType != '0'">详情</el-button>
						</template>
					</table-pagination>
		    </div>
		</section>
		<operateTable :title="drawer_title" :childBrand="listQuery.childBrandIdentify" ref="operateTable" @confirmEvent="confirmEvent"/>
		<updateStatus  ref="updateStatus" @getList="updateLists"/>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	import operateTable from './operateTable.vue';
	import updateStatus from './updateStatus.vue';
	import { tableMixin } from "utils/mixins";
	import {formatDate } from 'utils/index';
	export default {
		name:'Task',
		mixins:[tableMixin],
		components: {
			operateTable,
			updateStatus
		},
		computed: {
		    ...mapGetters([
				'userInfo',  
				'subBrandList'
			])
		},
		watch:{
			'$route':{
				handler(val){
					if(val.query.subjectId){
						this.listQuery.subjectId = val.query.subjectId;
					}
					if(val.path == '/breathe/task'){
						this.getList()
					}
				},
				// immediate:true
			},
			'listQuery.subjectId':{
				handler(val){
					if(val){
						let index = this.subjectLists.findIndex(el => el.subjectId == val);
						if(index != -1){
							this.listQuery.originalBatchNum = this.subjectLists[index].originalBatchNum;
						}
					}else {
						this.listQuery.originalBatchNum  = ''
					}
				}
			},
			'listQuery.originalBatchNum':{
				handler(val){
					localStorage.removeItem('checkedColumnIds');
					localStorage.removeItem('checkedColumn');
					this.checkedColumnIds = [];
					this.checkedColumn = [];
					this.column_visable = false;
				}
			}
		},
		data() {
			return {
				loading:false,
				filterHeader: [
					{label: '子品牌', model: 'childBrandIdentify', type: 'select', default: '', list: []},
					{label: '执行坐席', model: 'userId', type: 'selectRemote',  default: '', list: [], loading:false,isRemote:true,labelName:'account',valueName:'userId',disabled:false,childLabelName:'nickname'},
					{label: '外呼分类', model: 'campaignId', type: 'selectRemote', default: '',labelName:'campaignName',valueName:'campaignId'},
					{label: '外呼主题', model: 'subjectId', type: 'selectRemote', default: '',labelName:'subjectName',valueName:'subjectId'},
					{label: '任务状态', model: 'taskStatus', type: 'selectRemote', default: '',labelName:'statusName',valueName:'statusCode',multiple:true},
					{label: '外呼电话', model: 'phoneNumber', type: 'input', default: '', placeholder: '请输入外呼电话'},
					{label: '是否完成', model: 'isFinish', type: 'select', default: '', list: [{name:'是',id:'1'},{name:'否',id:'0'}]},
					{label: '任务编号', model: 'taskId', type: 'input', default: '', placeholder: '请输入任务编号'},
					{label: '外呼时间', model: 'date1', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '预约时间', model: 'date2', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '拨打时间', model: 'date3', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '任务创建时间', model: 'date4', type: 'datetimerange', default: '', placeholder: '请选择'},
					{label: '外呼次数', model: 'obTimes', type: 'input', default: '', placeholder: '请输入外呼次数'},
					{label: '数据文件', model: 'originalBatchNum', type: 'selectRemote', default: '',},
					{label: '自定义', model: 'customQueryParams', type: 'dynamic', default: ''},
				],
				dynamicHeader:[
					{label:'条件',inputVal:"",selectVal:'eq',model:''}
				],
				dynamicOptions:[],
				listQuery:{
					pageNumber:1,
					pageSize:10,
					brandIdentify:'',
					childBrandIdentify:'',
					subjectId:'',
					campaignId:'',
					taskStatus:'',
					phoneNumber:'',
					isFinish:'',
					taskId:'',
					date1:'',
					date2:'',
					date3:'',
					date4:'',
					obTimes:'',
					customQueryParams:'',
					startObTime:'',
					endObTime:'',
					originalBatchNum:'',
					customField:'',//自定义字段
				},
				assignNum:'',
				list:[],
				column:[],
				originColumn:[
					{ label: '选择', prop: 'selection', type: 'selection',align:'left' },
					{
					    label: '序号',
					    width: 150,
					    render: (h, scope) => {
					        return <span>{((this.listQuery.pageNumber - 1) * this.listQuery.pageSize) + (scope.$index + 1)}<span style="color:#f56c6c">{this.getTimeOut(scope.row)}</span></span>
					    }
					},
					{ label: '外呼主题', prop: 'subjectName' },
					{ label: '外呼问卷', prop: 'paperName' },
					{ label: '任务备注', prop: 'taskRemarks' },
					{ label: '任务开始时间', prop: 'subjectStartTime' },
					{ label: '任务结束时间', prop: 'subjectEndTime' },     
					{ label: '任务创建时间', prop: 'createTime' },     
					{ 
						label: '是否完成',
						 prop: 'isFinish' ,
						 render:(h,scope) => {return <span>{scope.row.isFinish == 0 ? '否' : '是'}</span>}
					},
					{ label: '预约时间', prop: 'appoinObTime' },
					{ label: '上一次任务时间', prop: 'lastObTime' },
					{
						label: '任务状态',
						 prop: 'taskStatus' ,
						 render:(h,scope) => {
							 return <span>{scope.row.taskStatusName}</span>
						 }
					},
					{ label: '已呼/限呼', prop: 'obTimesLimit',render:(h,scope) => {return <span>{scope.row.obTimes || 0} / {scope.row.obTimesLimit || '不限'}</span>} },
					{ label: '客户名称', prop: 'custName' },
					{ label: '执行坐席', prop: 'userNickname' },
					{ label: '执行外呼', prop: 'action' ,slotScope:true,fixed:'right', width: 360}
				],
				total:0,
				multipleSelectionAll: [], // 所有选中的数据包含跨页数据
				multipleSelection: [], // 当前页选中的数据
				idKey: "taskId",
				drawer_title:'',
				column_visable:false,
				isIndeterminate: true,
				checkAll: false,
				checkedColumnIds:localStorage.getItem('checkedColumnIds') ? JSON.parse(localStorage.getItem('checkedColumnIds')) : [],
				checkedColumn:localStorage.getItem('checkedColumn') ? JSON.parse(localStorage.getItem('checkedColumn')) : [],
				check_columns:[],
				brandName:process.env.VUE_APP_BRANDNAME,
				subjectLists:[],
			}
		},
		methods: {
			handleDetail(row){
				this.$router.push({
					path:`/breathe/callOut/info/${row.taskId}?type=details`
				})
			},
			// 主题列表
			onSubjectLists(data){
				this.subjectLists = data;
			},
			getTimeOut(row) {
				 if(!row.scheduleTime) return '';
				 if(row.isFinish == 1) return '';
				 let time_s = new Date(row.scheduleTime).getTime();
				 if(new Date().getTime() >= time_s ) return '【预约外呼到期】'
			     return '';
			},
			toCallout(row){
				this.$router.push({
					path:'/breathe/callOut/info/' + row.taskId
				})
			},
			onEdit(row){
				this.$router.push({
					path:`/breathe/callOut/info/${row.taskId}?type=edit`
				})
			},
			onCancelColumn(){
				this.column_visable = false;
				this.checkedColumnIds = [];
				this.checkedColumn = [];
				this.isIndeterminate = true;
			},
			toShowColumn(){
				if(!this.listQuery.originalBatchNum){
					this.$message.error('请先选择数据文件');
					return;
				}
				this.column_visable = true;
				this.$api.getBreathdataBaseColumnList({
					batchNum: this.listQuery.originalBatchNum,
					brandIdentify: this.listQuery.brandIdentify
				}).then(res => {
					if(res.errcode != 0) return;
					this.check_columns = res.data;
					this.checkedColumnIds = localStorage.getItem('checkedColumnIds') ? JSON.parse(localStorage.getItem('checkedColumnIds')) : [];
				})
			},
			onConfirmColumn(){
				this.checkedColumn =[];
				if(this.checkedColumnIds.length > 0) {
					this.check_columns.map(item => {
						this.checkedColumnIds.map(_item => {
							if(item.originalColumnCode == _item){
								this.checkedColumn.push({
									prop:item.originalColumnCode,
									label:item.originalColumnName
								})
							}
						})
					})
				}
				localStorage.setItem('checkedColumn',JSON.stringify(this.checkedColumn));
				if(this.checkedColumn.length > 0) {
					localStorage.setItem('checkedColumnIds',JSON.stringify(this.checkedColumnIds));
				}else {
					localStorage.setItem('checkedColumnIds','');
				}
				this.column = this.checkedColumn.length > 0 ? this.originColumn.concat(this.checkedColumn) : this.originColumn;
				this.column_visable = false;
				this.getList();
			},
			handleCheckAllChange(val){
				if(val){
					let ids = [];
					let results = [];
					this.check_columns.map(item => {
						ids.push(item.originalColumnCode);
					})
					this.checkedColumnIds = ids;
					
				}else {
					this.checkedColumnIds = [];
				}
				this.isIndeterminate = false;
			},
			handleCheckedChange(value){
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.check_columns.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.check_columns.length;
			},
			onTaskInfo(){
				this.$router.push(`/breathe/task/status`)
			},
			filterSearch() {
				// if(this.listQuery.date && this.listQuery.date.length > 0){
				// 	this.listQuery.startObTime = formatDate(this.listQuery.date[0], 'YYYY-MM-DD HH:mm:ss');
				// 	this.listQuery.endObTime = formatDate(this.listQuery.date[1], 'YYYY-MM-DD HH:mm:ss');
				// }
				this.listQuery.pageNum = 1;
				this.loading = true;
				this.getList()
			},
			resetBasicFilter(){
				this.dynamicHeader = [{label:'条件',inputVal:"",selectVal:'eq',model:''}]
			},
			updateLists(){
				this.multipleSelectionAll = [];
				this.multipleSelection = [];
				this.getList();
			},
			/* 选定坐席事件 */
			confirmEvent(data){
				let params;
				let taskIds = [];
				let userNicknames = [],userAccounts= [],userIds=[];
				this.multipleSelectionAll.map(item => {
					taskIds.push(item.taskId)
				})
				data.map(item => {
					userAccounts.push(item.account);
					userNicknames.push(item.nickname);
					userIds.push(item.userId);
				})
				if(this.drawer_title == '指定分配坐席') {
					params = {
						userIds:userIds.join(','),
						userAccounts:userAccounts.join(','),
						userNicknames:userNicknames.join(','),
						taskIds:taskIds.join(','),
						brandIdentify:this.userInfo.brandIdentify,
					}
				}else {
					let otherParams = {
						userIds:userIds.join(','),
						userAccounts:userAccounts.join(','),
						userNicknames:userNicknames.join(','),
						assignNum:this.assignNum,
						customQueryParams:this.getDynamicHeader(),
					}
					let query = JSON.parse(JSON.stringify(this.listQuery));
					delete query.pageNumber;
					delete query.pageSize;
					delete query.date;
					params = Object.assign(query,otherParams)
				}
				this.$api.toSpecifyBreathTask(params, this.listQuery).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success('分配成功');
					this.$refs.operateTable.onCancel();
					this.updateLists();
					this.assignNum = 0;
				})
			},
			handleSelectionChange(row){
				this.multipleSelection = row;
			},
			async onBatch(){
				if(!this.listQuery.taskStatus) return this.$message.error('请设置任务状态为未分配');
				if(this.total == 0) return this.$message.error('暂无可分配的任务');
				if(!this.assignNum) return this.$message.error("请先填写分配数量");
				this.drawer_title = '自动分配坐席';
				this.$refs.operateTable.onShow();
			},
			onSpecify(){
				// if(!this.listQuery.taskStatus) return this.$message.error('请设置任务状态为未分配');
				if(this.total == 0) return this.$message.error('暂无可分配的任务');
				this.changePageCoreRecordData();
				if (this.multipleSelectionAll.length <= 0) {
					// this.$message({
					// 	message: "无勾选数据！",
					// 	type: "warning"
					// });
					// return;
					this.$confirm(`是否将 ${this.total} 条任务指定分配给坐席？`, '系统提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.drawer_title = '指定分配坐席';
						this.$refs.operateTable.onShow();
					}).catch(() => {});    
				} else {
					this.drawer_title = '指定分配坐席';
					this.$refs.operateTable.onShow();
				}
				      
				
			},
			onResetTask(row){
				this.$confirm('确定要重开这个任务吗?', '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.reOpenTaskBreathTask({
						taskId: row.taskId,
						brandIdentify:row.brandIdentify
					}).then(response => {
						if(response.errcode != 0) return;
						this.$notify.success('重开成功');
						this.getList();
					});
				}).catch(() => {});
			},
			onSpecifyToPerson(row){
				this.drawer_title = '指定分配坐席';
				this.$refs.operateTable.onShow();
				this.multipleSelectionAll = [row]
			},
			onStatus(){
				this.changePageCoreRecordData();
				if (this.multipleSelectionAll.length <= 0) {
					this.$message({
						message: "无勾选数据！",
						type: "warning"
					});
					return;
				}
				this.$refs.updateStatus.onShow(this.multipleSelectionAll)
			},
			async getList(val){
				if(val){
					this.changePageCoreRecordData();
				}
				this.listQuery.customField = this.checkedColumnIds.length > 0  ? this.checkedColumnIds.join(',') : '';
				this.listQuery.brandIdentify = this.userInfo.brandIdentify;
				this.listQuery.customQueryParams = this.getDynamicHeader();
				let params = JSON.parse(JSON.stringify(this.listQuery));
				delete params.date;
				await this.$api.getBreathTaskList(params).then(response => {
					this.loading = false;
					if(response.errcode != 0) return;
					this.column = (this.checkedColumn.length > 0 && this.userInfo.brandIdentify == this.brandName) ? this.originColumn.concat(this.checkedColumn) : this.originColumn;
					this.$nextTick(() => {
						this.list = response.data;
						this.total = parseInt(response.total);
						setTimeout(() => {
							this.setSelectRow('taskTable');
						}, 20);
					})
				}).catch(err => {
					this.loading = false;
				})
			},
			addDynamic(){
				this.dynamicHeader.push({label:'条件',inputVal:"",selectVal:'eq',model:''});
			},
			removeDynamic(index){
				 this.dynamicHeader.splice(index, 1)
			},
			// getTaskStatus(){
			// 	this.$api.getBreathTaskStatus({
			// 		brandIdentify:this.userInfo.brandIdentify
			// 	}).then(res => {
			// 		if(res.errcode != 0) return;
			// 		this.filterHeader[3]['list'] = res.data;
			// 	})
			// },
			getDynamicHeader(){
				let results =[];
				this.dynamicHeader.map(item => {
					if(item.model && item.inputVal){
						results.push(`${item.model}::${item.selectVal}::${item.inputVal}`)
					}
				})
				results = results.length > 0 ? results.join('#') : '';
				return results;
			},
			onDynamicEvent(){
				if(!this.listQuery.originalBatchNum){
					this.$message.error("请先选择数据文件");
					return;
				}
				this.$api.getBreathdataBaseColumnList({
					batchNum: this.listQuery.originalBatchNum,
					brandIdentify: this.listQuery.brandIdentify
				}).then(res => {
					if(res.errcode != 0) return;
					this.dynamicOptions = res.data;
				})
			},
		},
		created() {
			this.filterHeader[0]['list'] = this.subBrandList;
			this.loading = true;
			this.$nextTick(() => {
				if(this.userInfo.userType == 0) {
					this.filterHeader[1].disabled = true;
					this.listQuery.userId = this.userInfo.userId;
					this.$refs.tableSearch.geUserId(this.filterHeader[1],this.userInfo.account)
				}
				this.listQuery.childBrandIdentify = this.userInfo.brandList && this.userInfo.brandList.length > 0 ? this.userInfo.brandList[0] : '';
				this.getList();
			})
		},
	}
</script>

<style lang="scss" scoped>
	.breath-task {
		.btns {
			display: flex;
			align-items: center;
		}
	}
	.task_checkbox {
		display: flex;
		flex-direction: column;
	}
	
</style>
